import { createElementVNode, defineComponent, ref, watch, onMounted, nextTick, openBlock, createElementBlock, Fragment, renderList, createBlock, resolveDynamicComponent, mergeProps, withCtx, toDisplayString, Teleport, normalizeClass, createCommentVNode } from 'vue';
import { useClickOutside } from '../../../hooks/useClickOutside/index.mjs';
import { WEBSITE } from '../../../utils/getConstant.mjs';

const _hoisted_1 = { class: "tvb-mobile-menu-container" };
const _hoisted_2 = { class: "tvb-mobile-menu-items" };
const _hoisted_3 = { class: "tvb-mobile-menu-item-text" };
const _hoisted_4 = /* @__PURE__ */ createElementVNode("span", { class: "after" }, null, -1);
const _hoisted_5 = {
  key: 0,
  class: "tvb-mobile-sub-menu"
};
const _hoisted_6 = { class: "tvb-mobile-sub-menu-item-text" };
const _hoisted_7 = /* @__PURE__ */ createElementVNode("span", { class: "after" }, null, -1);
const __default__ = defineComponent({
  name: "TvbMobileMenu"
});
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: {
    menus: null,
    h: null,
    menuKey: null,
    fullPath: null
  },
  emits: ["click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const TvbMobileMenuRef = ref();
    const isClickOutside = useClickOutside(TvbMobileMenuRef);
    const sub_menu = ref([]);
    const menu = ref(props.menus);
    const resetHover = () => {
      menu.value.map((_menu) => {
        _menu.hover = false;
        return _menu;
      });
    };
    const clickJump = (_menu, event) => {
      resetHover();
      sub_menu.value = (_menu == null ? void 0 : _menu.sub_menu) || [];
      if (sub_menu.value.length) {
        _menu.hover = true;
      }
      emits("click", { ..._menu, event, event_label: "main-sub-menu" });
    };
    ;
    watch(isClickOutside, (isClickOutside2) => {
      if (isClickOutside2) {
        sub_menu.value = [];
      }
    });
    watch(sub_menu, (sub_menu2) => {
      document.body.style.overflow = sub_menu2.length ? "hidden" : "";
    });
    watch(
      () => props.menus,
      (menus) => {
        menu.value = menus;
      }
    );
    onMounted(() => {
      menu.value = props.menus;
    });
    const computedActive = () => {
      menu.value.map((_menu) => {
        _menu.active = false;
        try {
          const url = new URL(_menu == null ? void 0 : _menu.jump_url);
          if (WEBSITE.includes(url.origin)) {
            _menu.active = location.pathname === url.pathname;
            return menu;
          } else if (location.pathname && location.pathname !== "/") {
            _menu.active = url.href.includes(location.pathname);
            return _menu;
          } else {
            return _menu;
          }
        } catch (error) {
          return _menu;
        }
      });
      nextTick(() => {
        if (document.querySelector(".tvb-mobile-menu-item.active")) {
          const { left, width } = document.querySelector(".tvb-mobile-menu-item.active").getBoundingClientRect();
          const rootEl = document.querySelector(".tvb-mobile-menu-container");
          const rootElClientRect = rootEl.getBoundingClientRect();
          rootEl.scroll({
            left: left - 12 - rootElClientRect.width / 2 - rootElClientRect.left + width,
            top: 0,
            behavior: "smooth"
          });
        }
      });
    };
    watch(
      () => props.fullPath,
      () => computedActive()
    );
    onMounted(() => computedActive());
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "TvbMobileMenuRef",
        ref: TvbMobileMenuRef,
        class: "tvb-mobile-menu"
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", _hoisted_2, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(menu.value, (_menu, index) => {
              return openBlock(), createBlock(resolveDynamicComponent((_menu == null ? void 0 : _menu.jump_url) ? "a" : "span"), mergeProps({ key: index }, {
                rel: (_menu == null ? void 0 : _menu.link_rel) === 1 ? "follow" : (_menu == null ? void 0 : _menu.link_rel) === 2 ? "nofollow" : "",
                target: (_menu == null ? void 0 : _menu.link_target) === 1 ? "_self" : (_menu == null ? void 0 : _menu.link_target) === 2 ? "_blank" : ""
              }, {
                class: ["tvb-mobile-menu-item", { active: _menu.active, hover: (_menu == null ? void 0 : _menu.hover) || false }],
                href: (_menu == null ? void 0 : _menu.jump_url) || null,
                onClick: (event) => clickJump(_menu, event)
              }), {
                default: withCtx(() => [
                  createElementVNode("h2", _hoisted_3, toDisplayString(_menu == null ? void 0 : _menu.title), 1),
                  _hoisted_4
                ]),
                _: 2
              }, 1040, ["href", "class", "onClick"]);
            }), 128))
          ])
        ]),
        (openBlock(), createBlock(Teleport, { to: "body" }, [
          createElementVNode("div", {
            class: normalizeClass(["tvb-mobile-sub-menu-container", { show: !!sub_menu.value.length }]),
            onClick: resetHover
          }, [
            sub_menu.value.length ? (openBlock(), createElementBlock("div", _hoisted_5, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(sub_menu.value, (_menu, index) => {
                return openBlock(), createBlock(resolveDynamicComponent((_menu == null ? void 0 : _menu.jump_url) ? "a" : "span"), mergeProps({ key: index }, {
                  rel: (_menu == null ? void 0 : _menu.link_rel) === 1 ? "follow" : (_menu == null ? void 0 : _menu.link_rel) === 2 ? "nofollow" : "",
                  target: (_menu == null ? void 0 : _menu.link_target) === 1 ? "_self" : (_menu == null ? void 0 : _menu.link_target) === 2 ? "_blank" : ""
                }, {
                  class: "tvb-mobile-sub-menu-item",
                  href: (_menu == null ? void 0 : _menu.jump_url) || null,
                  onClick: (event) => clickJump(_menu, event)
                }), {
                  default: withCtx(() => [
                    createElementVNode("h3", _hoisted_6, toDisplayString(_menu == null ? void 0 : _menu.title), 1),
                    _hoisted_7
                  ]),
                  _: 2
                }, 1040, ["href", "onClick"]);
              }), 128))
            ])) : createCommentVNode("v-if", true)
          ], 2)
        ]))
      ], 512);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=Mobile.vue2.mjs.map
